import React, { useRef, useState } from 'react';
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardTitle,
    PageSection,
} from '@patternfly/react-core';
import useLogger from 'src/hooks/useLogger';
import { formatTimestamp } from '../../utils/formatters';

export const LogsDisplay: React.FC = () => {
    const { logs } = useLogger();
    const [showLogs, setShowLogs] = useState(true);
    const logContainerRef = useRef<HTMLDivElement>(null);

    return (
        <PageSection>
                <Card>
                    <CardTitle>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>System Logs</span>
                            <Button
                                onClick={() => setShowLogs(!showLogs)}
                                variant="link"
                            >
                                {showLogs ? 'Hide' : 'Show'}
                            </Button>
                        </div>
                    </CardTitle>
                    {showLogs && (
                        <CardBody>
                            <div
                                ref={logContainerRef}
                                style={{
                                    height: '200px',
                                    overflowY: 'auto',
                                    backgroundColor: '#f0f0f0',
                                    padding: '10px',
                                    fontFamily: 'monospace',
                                    fontSize: '14px',
                                    borderRadius: '4px',
                                    userSelect: 'text',
                                    cursor: 'default'
                                }}
                            >
                                {logs.map((log, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            marginBottom: '4px',
                                            padding: '4px',
                                            borderRadius: '2px',
                                            backgroundColor: log.level === 'error' ? '#ffebee' :
                                                log.level === 'warn' ? '#fff8e1' : 'transparent',
                                            display: 'flex',
                                            alignItems: 'flex-start'
                                        }}
                                    >
                                        <span style={{
                                            color: '#666',
                                            marginRight: '8px',
                                            minWidth: '80px'
                                        }}>
                                            {formatTimestamp(log.timestamp)}
                                        </span>
                                        <Badge style={{ marginRight: '8px' }} isRead={log.level !== 'error'}>
                                            {log.level.toUpperCase()}
                                        </Badge>
                                        <span style={{
                                            color: log.level === 'error' ? '#d32f2f' :
                                                log.level === 'warn' ? '#ff8f00' : '#212121',
                                            wordBreak: 'break-word'
                                        }}>
                                            {log.message}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </CardBody>
                    )}
                </Card>
            </PageSection>
    );
};